export interface CommentForm {
  body?: string;
}

export const commentFormDefaultValues: CommentForm = {
  body: '',
};
